import React from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {StreamBankLink} from "../../Common/StreamBankLink";
import {FileVisibilityHelper} from "../../Common/Files/FileVisibilityHelper";

export class SurveyNameTableColumn extends BaseTableColumn {
    constructor() {
        super();
    }

    @autobind
    _render() {
        const {SurveyType, surveyId} = this.props.rowData;
        return <div className="cell-with-spaced-content">
            <StreamBankLink
                className="sb-actionable-link"
                Href={"/surveys/" + surveyId}
            >
                {this.props.Value}
            </StreamBankLink>
            <FileVisibilityHelper file={{
                auditorVisibility: SurveyType?.isHiddenFromAuditor ? false : `${SurveyType?.name} surveys are visible to auditors.`,
                publicVisibility: SurveyType?.isHiddenFromPublic ? false : `${SurveyType?.name} surveys are visible to the public.` ,
            }} />
        </div>;
    }
}
